// export function defaultParams() {
//   const productType = localStorage.getItem("product-type");
//   // const productId = productType ? removeHash(JSON.parse(productType)) : 6;
//   const productId = 6;

import { PRODUCT_ID } from "../config/global.config";
import { removeHash } from "../lib/crypto";

//   return {
//     productId: productId,
//   };
// }

export function defaultHeaders(headers: Headers, token?: string) {
  const defaultHeader: Headers = headers;

  if (token) {
    defaultHeader.set("Authorization", `Bearer ${token}`);
  }

  defaultHeader.set("ngrok-skip-browser-warning", "true");

  const productType = localStorage.getItem("product-type");
  const productId =
    (productType
      ? (removeHash(JSON.parse(productType)) as string)
      : PRODUCT_ID) || PRODUCT_ID;
  defaultHeader.set("productId", productId?.toString() as string);

  return defaultHeader;
}
